import { Spin } from 'antd'
import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import WhatsappButton from 'components/atoms/WhatsappButton'
import { ScrollToTop } from 'utils/ScrollToTop'
import PopupNotification from 'components/organisms/PopupNotification'

const BlankLayout = () => {
  return (
    <main className="min-h-screen flex items-center justify-center lg:py-16 py-4 px-4">
      <PopupNotification />
      <ScrollToTop />
      <Suspense
        fallback={
          <div
            className="
        flex justify-center items-center flex-col h-screen w-full flex-grow">
            <Spin size="large" spinning={true}></Spin>
          </div>
        }>
        <Outlet />
      </Suspense>
      <WhatsappButton />
    </main>
  )
}

export default BlankLayout
